import { Component, OnInit } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { ErrorMessageService } from 'src/app/interceptor/error-interceptor.service';
import { AuthService } from 'src/app/services/auth/auth.service';

@Component({
  selector: 'app-forget-password',
  templateUrl: './forget-password.component.html',
  styleUrls: ['./forget-password.component.scss'],
})
export class ForgetPasswordComponent implements OnInit {
  mail: string | any;
  successResponse = false;
  errorResponse = false;
  errorMessage: string = '';
  loading = false;
  constructor(private authService: AuthService, private errorMessageService: ErrorMessageService) { }

  ngOnInit() { }

  sendMail() {
    this.loading = true;
    this.successResponse = false;
    this.errorResponse = false;

    this.authService
      .resetPassword(this.mail)
      .pipe(finalize(() => (this.loading = false)))
      .subscribe(
        (resp) => {
          this.successResponse = true;
        },
        (error) => {
          this.errorMessage = this.errorMessageService.getMessage(error.error?.customMessage, {
            customMessage: 'Ocorreu um erro ao tentar realizar o envio do e-mail de recuperação. Por favor, tente novamente.',
          });
          this.errorResponse = true;
        }
      );
  }

  useAnotherEmail() {
    this.mail = '';
    this.successResponse = false;
    this.errorResponse = false;
  }
}
